<template>
  <v-card
    class="stock-invoice-totals-panel"
    :class="`stock-invoice-totals-panel--${direction || 'outgoing'}`"
    elevation="4"
  >
    <v-card-title class="stock-invoice-totals-panel__title pb-2">
      <v-icon left :color="direction === 'incoming' ? 'deep-purple darken-1' : 'teal darken-1'">
        mdi-calculator-variant
      </v-icon>
      {{ $t("STOCK.INVOICES.TOTALS") }}
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pt-4">
      <div class="stock-invoice-totals-panel__row">
        <span class="stock-invoice-totals-panel__label">{{ $t("STOCK.INVOICES.NET") }}</span>
        <span class="stock-invoice-totals-panel__value">{{ formatMoney(net) }}</span>
      </div>
      <div class="stock-invoice-totals-panel__row">
        <span class="stock-invoice-totals-panel__label">{{ $t("STOCK.INVOICES.VAT") }}</span>
        <span class="stock-invoice-totals-panel__value stock-invoice-totals-panel__value--vat">
          {{ formatMoney(vat) }}
        </span>
      </div>
      <v-divider class="my-3"></v-divider>
      <div class="stock-invoice-totals-panel__row stock-invoice-totals-panel__row--gross">
        <span class="stock-invoice-totals-panel__label">{{ $t("STOCK.INVOICES.GROSS") }}</span>
        <span class="stock-invoice-totals-panel__value stock-invoice-totals-panel__value--gross">
          {{ formatMoney(gross) }}
        </span>
      </div>
      <div v-if="currencyCode" class="stock-invoice-totals-panel__currency caption text-center mt-2">
        {{ currencyCode }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StockInvoiceTotalsPanel",
  props: {
    net: { type: [Number, String], default: 0 },
    vat: { type: [Number, String], default: 0 },
    gross: { type: [Number, String], default: 0 },
    currencyCode: { type: String, default: "" },
    direction: { type: String, default: "outgoing" },
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toFixed(2);
    },
  },
};
</script>

<style scoped>
.stock-invoice-totals-panel {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}
.stock-invoice-totals-panel--outgoing .stock-invoice-totals-panel__title {
  background: linear-gradient(to right, #e0f7fa, #ffffff);
}
.stock-invoice-totals-panel--incoming .stock-invoice-totals-panel__title {
  background: linear-gradient(to right, #ede7f6, #ffffff);
}
.stock-invoice-totals-panel--incoming .stock-invoice-totals-panel__value--gross {
  color: #4527a0;
}
.stock-invoice-totals-panel__title {
  font-size: 1rem !important;
}
.stock-invoice-totals-panel__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 6px 0;
}
.stock-invoice-totals-panel__label {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.9rem;
}
.stock-invoice-totals-panel__value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.stock-invoice-totals-panel__value--vat {
  color: #6a1b9a;
}
.stock-invoice-totals-panel__value--gross {
  font-size: 1.35rem;
  font-weight: 700;
  color: #00695c;
}
.stock-invoice-totals-panel__row--gross {
  padding-top: 4px;
}
</style>
